import { render, staticRenderFns } from "./ListCategoryView.vue?vue&type=template&id=cf15fd96"
import script from "./ListCategoryView.vue?vue&type=script&lang=ts"
export * from "./ListCategoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports